import { render, staticRenderFns } from "./ModelFile.vue?vue&type=template&id=796148b7&"
import script from "./ModelFile.vue?vue&type=script&lang=js&"
export * from "./ModelFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports